// src/ChatLayout.tsx
import { jsx } from "react/jsx-runtime";
function ChatComposerLayout({ children, className = "", variant, ...props }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `photon-composer photon-composer--${variant} ${className}`.trim(),
      ...props,
      children
    }
  );
}
function ChatNavigationLayout({ children, className = "", variant, ...props }) {
  return /* @__PURE__ */ jsx(
    "section",
    {
      className: `photon-navigation photon-navigation--${variant} ${className}`.trim(),
      ...props,
      children
    }
  );
}

export {
  ChatComposerLayout,
  ChatNavigationLayout
};
